import { AxiosRequestConfig } from "axios";
import { Tokens } from "../../types/webchatConversation";
import { getCookie } from "./cookies";

const getAxiosConfig = (
  methodVal: any,
  urlVal: string,
  headersVal: string,
  dataVal?: Record<string, unknown>,
  paramsVal?: Record<string, unknown> | string,
): AxiosRequestConfig => {
  const headers = {
    "Content-Type": "application/json",
  };

  if (headersVal.toLocaleLowerCase() === "bearer") {
    const jwtToken =
      getCookie(Tokens.GUEST_TOKEN) ||
      localStorage.getItem(Tokens.GUEST_TOKEN) ||
      getCookie(Tokens.AUTH_TOKEN) ||
      localStorage.getItem(Tokens.AUTH_TOKEN);

    if (jwtToken) {
      headers["Authorization"] = `Bearer ${jwtToken}`;
    }
  }

  const config: AxiosRequestConfig = {
    method: methodVal,
    url: `${process.env.REACT_APP_HOST}${urlVal}`,
    headers,
  };

  if (dataVal) config["data"] = dataVal;
  if (paramsVal) config["params"] = paramsVal;

  return config;
};

export default getAxiosConfig;
